import { Skeleton } from '@mui/material';
import { COLOR_STROKE } from 'shared';

import { ListItemStyled } from '../styled';

export const ReferralItemLoader = () => {
  return (
    <ListItemStyled>
      <Skeleton variant="rounded" width="100%" height={22} />
    </ListItemStyled>
  );
};
